<ng-container *ngIf="titleText && titleText != ''">
    <!-- seleccion tag -->
    <ng-container [ngSwitch]="titleTag">
        <h1 *ngSwitchCase="'h1'"   class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></h1>
        <h2 *ngSwitchCase="'h2'"   class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></h2>
        <h3 *ngSwitchCase="'h3'"   class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></h3>
        <h4 *ngSwitchCase="'h4'"   class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></h4>
        <h5 *ngSwitchCase="'h5'"   class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></h5>
        <h6 *ngSwitchCase="'h6'"   class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></h6>
        <div *ngSwitchCase="'div'" class="contentTitle {{class}}"><ng-template [ngTemplateOutlet]="templateEnlace"></ng-template></div>
        <p *ngSwitchCase="'p'"     class="contentTitle {{class}}"></p>
        <ng-container *ngSwitchDefault>
            <div  class="contentTitle {{class}}" >
                <ng-template [ngTemplateOutlet]="templateEnlace"></ng-template>
            </div>
        </ng-container>        
    </ng-container>
</ng-container>

<ng-template #templateEnlace>    
    <ng-container *ngIf="linkHref && linkHref != ''; else templateTexto">
        <a 
        href="{{linkHref}}" 
        title="{{(linkTitle) ? linkTitle : ''}}"
        target="{{(linkTarget) ? linkTarget : ''}}"
        rel="{{(linkRel) ? linkRel : ''}}"
        >
        <ng-template [ngTemplateOutlet]="templateTexto"></ng-template>
        </a>    
    </ng-container>
    
    <ng-template #templateTexto>
        {{titleText}}
    </ng-template>
</ng-template>


<ng-template #templateImagen>
    <div class="contentPicture" [ngClass]="class">      
        <picture>
            <img src="{{imgSrc}}" alt="'alt'"/>
        </picture>
    </div>
</ng-template>

